/*
GPS DataViz

Copyright © 2021 GPSDataViz

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

import React from "react";
import { Button, Divider } from 'antd';
import { Link } from 'react-router-dom';
import '../../Styles/styles-About.css';
import Logo1 from '../../Images/newlogo1-01.png'
import { OnBoardingNav } from "../Navigation/OnBoardingNav";
import { Carousel } from 'antd';


function onChange(a, b, c) {
    console.log(a, b, c);
  }

  export class About extends React.Component{
    // state = {
    //     username:"",
    //     password: "",
    //     error: "",
    //     logged_in: false
    // }; 

    render(){
        return <>
            <div>
                <OnBoardingNav />
                <div>
                    <div>
                    <head>
                    <link rel="stylesheet" href="https://use.typekit.net/uxr7gkj.css"/>
                    </head>
                    <div className="paragraph-one">
                    <img className="onboarding-logo" src={Logo1} alt="header-logo"/>
                    <div className="content">
                    <p className="description1">GPS DataViz is an innovative cost-effective solution to easily get actionable insights from your daily data collection.  We efficiently manage your data and optimize your weekly practice planning, using machine learning and predictive analytics to ensure your players are match-fit, keep them healthy and help your team <b className="onboarding-styled-text">WIN MORE GAMES!</b></p>
                    </div>
                    </div>
                    <div className="search-divider"><Divider></Divider></div>
                        <div className="paragraph-two">
                            <div className="content">
                                <ul className="onboarding-list">GPS DataViz is built by coaches for coaches and uses a seamless data integration to give you instant feedback as soon as you’re done training regarding:
                                    <li className="onboarding-elements onboarding-top-element">What you did today at training</li>
                                    <li className="onboarding-elements">What you need to do tomorrow at training</li>
                                    <li className="onboarding-elements">Which players are overworked</li>
                                    <li className="onboarding-elements">Which players are underperforming</li>
                                    <li className="onboarding-elements">Who is getting faster</li>
                                </ul>
                            <p className="description1">Don’t let your season be derailed by injuries, sign up with GPS DataViz today and immediately get detailed feedback from training right in your inbox.  Track injuries and lifts, compare outputs from various drills, training sessions or games and receive automated reports telling you which players are gaining fitness, at risk of injury or need to train harder. <b className="onboarding-styled-text">Make your program better!</b></p>
                            </div>
                        </div>
                        <div className="search-divider"><Divider></Divider></div>
                        <p className="description2">Contact <b>info@gpsdataviz.com</b> for more information.</p>
                    </div>

                </div>
            </div>
        </>
    }
}